import { BsFolder } from 'react-icons/bs';
import styled from 'styled-components';
import colors from '../../styles/colors';

export const Container = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ContainerUpload = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3 {
    margin-right: 135px;
  }
`;

export const UploadLine = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const DirectoryInput = styled.input`
  width: 10px;
  height: 10px;
  z-index: -1;
`;

export const PathInput = styled.input`
  width: 65%;
  height: 38px;
  border-radius: 0.5rem;
  border: none;
  margin-top: 12px;
  margin-right: 3rem;
  background-color: #f1f1f1;
  color: #626262;
`;

export const TextLabel = styled.label`
  font-family: 'Roboto';
  padding: 5px 10px;
  width: px;
  border-radius: 0.5rem;
  background-color: ${colors.aux1};
  color: #fff;
  text-align: center;
  display: block;
  margin-top: 10px;

  transition: filter 0.2s;

  &:hover {
    filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.5));
  }
`;

export const DirectoryIcon = styled(BsFolder)`
  height: 25px;
  width: 25px;
`;

export const Message = styled.h2`
  font-size: 1.2rem;
  line-height: 1.5rem;
  width: 80%;
  text-align: center;
  font-weight: bold;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;
